import props from '../../redux/props'
import { useSelector } from 'react-redux'

const useTranslation = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return t
}

export default useTranslation
